type SectionHeadingProps = {
  id?: string
  index?: string
  eyebrow?: string
  title: string
  description?: string
  align?: 'left' | 'center'
}

export default function SectionHeading({
  id,
  index,
  eyebrow,
  title,
  description,
  align = 'left',
}: SectionHeadingProps) {
  return (
    <div className={`section-heading section-heading--${align}`}>
      {(index || eyebrow) && (
        <p className="eyebrow section-coordinate">
          {index && <span>{index}</span>}
          {eyebrow}
        </p>
      )}
      <h2 id={id}>{title}</h2>
      {description && <p>{description}</p>}
    </div>
  )
}
